import React, { useContext, useState } from 'react';
import { BetslipContext } from '../../data/betslip/BetslipConf';
import { formatDate, getDBTimestampFromDate } from '../../data/utils';
import { getLabel } from '../../InitData';
import { ReservationPrinter } from '../../data/betslip/reservation-detail/ReservationPrinter';

function ReservationHistory(props) {
	const betslipContext = useContext(BetslipContext) ;
    let reservations = props.reservations;
    const [printCodes, setPrintCodes] = useState(null);
    function getFormattedDate(timestamp){
    	const reservationDate = new Date();
		reservationDate.setTime(timestamp);
		return formatDate(getDBTimestampFromDate(reservationDate), true).formatted;
    }
    
    function printReservation(code) {
		setPrintCodes({codeList : [code]});
    }
    
   function endPrintFunction(){
    	if (window.appConfig.SHOP_BOOKER || window.appConfig.SELF_CASHIER) {
    		if(printCodes.codeList.length > 1){
    			 betslipContext.clearReservations();
    		}
    		else {
	            betslipContext.removeReservation(printCodes.codeList[0]);	
    		}
        }
        setPrintCodes(null);
    }

    function printAll() {
		const codeList = [];
		const resv = betslipContext.getReservations();
		for(let kr in resv){
			codeList.push(resv[kr].code);
		}
		setPrintCodes({codeList});
    }

    return (
        <div className="reservationHistory">
        	{printCodes && <ReservationPrinter codeList={printCodes.codeList} endFunction={() => { endPrintFunction(); }} />}
            <div className="reservationHeader">{getLabel('carrello.reservations_made')}: {reservations.length} </div>
            <div className="reservationListContainer">		
                {reservations.map(res => {
                    const reactKey = 'reservation-' + res.code;
                    return <React.Fragment key={reactKey}>
                        <div className="reservationRow">
                            <div onClick={() => {betslipContext.removeReservation(res.code)}} className="deleteReservation pointer"> <i className="fa fa-times"></i> </div>
                            <div className="inputReservationContainer reservationData">
                                <span className="reservationTimestamp">{getFormattedDate(res.timestamp)}</span> {res.code}
                            </div>
                            <div className="reservationButtonsContainer reservationButtons">
                                <div onClick={() => betslipContext.openReservationDetail(res.code)} className="reloadReservationButton">
                                    <span>{getLabel('carrello.reservations.detail')}</span>
                                    <i className="fa fa-ticket-alt"></i>
                                </div>
                                <div onClick={() => {printReservation(res.code)}} className="reloadReservationButton">
                                    <span>{getLabel('carrello.reservations.print')}</span>
                                    <i className="fa fa-print"></i>
                                </div>
                                <div onClick={() => {betslipContext.reloadReservedTicket(res.code)}} className="reloadReservationButton">
                                    <span>{getLabel('carrello.reservations.load')}</span>
                                    <i className="fa fa-shopping-cart"></i>
                                </div>
                            </div>
                        </div>
                    </React.Fragment>
                })}
            </div>
            <div className="closeReservationButtonContainer">
                <button onClick={() => {betslipContext.toggleReservationBox()} } className="bottone bg-rosso bianco">{getLabel('carrello.reservations.close')}</button>
                {(window.appConfig.SHOP_BOOKER || window.appConfig.SELF_CASHIER) &&
                    <button onClick={() => printAll() } className="bottone bg-rosso bianco margine-sx">Stampa tutte</button>
                }
            </div>
        </div>
   );
}

export default ReservationHistory;